<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import {computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import AlternativeLogins from "@/components/LoginForm/AlternativeLogins.vue";

const showPassword = ref(false);
const showConfirmPassword = ref(false);

defineEmits(['show-login']);

const {t} = useI18n(); // Use the i18n instance
</script>

<template>
  <div class="register-container w-1/2">
    <h1 class="form-title__text responsive-title-4 font-semibold self-start">{{ t('signup.title') }}</h1>
    <div class="flex flex-col mt-4 gap-y-3">
      <div class="flex flex-row gap-x-4">
        <VTextField :label="t('signup.firstName')" variant="underlined"/>
        <VTextField :label="t('signup.lastName')" variant="underlined"/>
      </div>
      <VTextField :label="t('signup.email')" variant="underlined"></VTextField>
      <VTextField :label="t('signup.password')" variant="underlined" :type="showPassword ? 'text' : 'password'">
        <template v-slot:append-inner>
          <div class="w-6 cursor-pointer" @click="showPassword = !showPassword" v-if="showPassword">
            <img src="@/assets/icons/svg/Hide_24x24.svg" :alt="t('signup.hide')" width="64">
          </div>
          <div class="w-6 cursor-pointer" @click="showPassword = !showPassword" v-else>
            <img src="@/assets/icons/svg/Show_24x24.svg" :alt="t('signup.show')" width="64">
          </div>
        </template>
      </VTextField>
      <VTextField :label="t('signup.confirmPassword')" variant="underlined"
                  :type="showConfirmPassword ? 'text' : 'password'">
        <template v-slot:append-inner>
          <div class="w-6 cursor-pointer" @click="showConfirmPassword = !showConfirmPassword"
               v-if="showConfirmPassword">
            <img src="@/assets/icons/svg/Hide_24x24.svg" :alt="t('signup.hide')" width="64">
          </div>
          <div class="w-6 cursor-pointer" @click="showConfirmPassword = !showConfirmPassword" v-else>
            <img src="@/assets/icons/svg/Show_24x24.svg" :alt="t('signup.show')" width="64">
          </div>
        </template>
      </VTextField>
      <VCheckbox class="sign-up-form" :label="t('signup.newsletter')"/>
    </div>
    <form class="flex flex-col">
      <CustomButton size="md-large" type="black" :rounded="true" class="form-register__btn w-[15vw]  responsive-body-large mt-3 font-semibold">{{
          t('signup.signUp')
        }}
      </CustomButton>
      <div class="already-user__text font-semibold text-md mt-6">{{ t('signup.alreadyHaveAccount') }} <span
          class="underline cursor-pointer ml-2" @click="$emit('show-login')">{{ t('signup.login') }}</span></div>
    </form>
    <AlternativeLogins/>
  </div>
</template>

<style scoped>
:deep(.custom-checkbox-label .v-label) {
  font-size: 10px;
}

:deep(.sign-up-form .v-label) {
  font-size: .875rem;
  opacity: 1;
}

:deep(.sign-up-form .v-selection-control__wrapper) {
  margin-top: -1rem
}

:deep(.v-input__details) {
  display: none;
}

:deep(.v-input__details:has(.v-messages__message)) {
  display: block;
}

input {
  @apply m-2 p-2 border border-gray-300 rounded-md;
}

.form-register__btn {
  font-size: 1rem !important;
}

@media (max-width: 1538px) {
  .form-title__text {
    font-size: 1.5rem;
  }
  :deep(.sign-up-form .v-label) {
    font-size: .75rem;
  }
}

@media (max-width: 1385px) {
  .register-container {
    width: 65%;
  }
  .form-register__btn {
    font-size: 1rem;
  }
}

@media (max-width: 1024px) {
  .register-container {
    width: 60%;
  }

  .form-title__text {
    font-size: 1.5rem;
  }
  .form-register__btn {
    width: 18vw;
  }
  .already-user__text {
    font-size: .875rem;
  }
}

@media (max-width: 768px) {
  .btn {
    font-size: 12px;
  }

  .register-container {
    width: 80%;
  }

  .form-title__text {
    font-size: 1.25rem;
  }
  .form-register__btn {
    width: 100%;
    font-size: .875rem;
  }
  .already-user__text {
    font-size: .75rem;
  }
}
</style>
